// ======================================================================
// File Name       : ContentHistorySearchResult
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead from '../../../components/TableHead';
import * as Path from '../../../constants/PathConstants';
import { getItemBoxName } from '../../../utils/index';
import { convertContentHistoryObjectToList } from '../../../utils/ContentUtils';
import { CONTENT_TYPE_STR } from '../../../constants/ContentHistoryConstant';
import ReduxFormPaging from '../../ReduxFormPaging';
import CustomLink from '../../button/CustomLink';
import * as ICON from '../../../constants/IconConstants';


const ContentHistorySearchResult = ({ itemListInfo,
  handleSortState,
  goToDetail,
  dataSort,
  eachItemStatusCount,
  recordNum,
  startPosition,
  getStartEndData,
  handleMouseEnter,
  handleMouseLeave,
 }) => {
  const thead = [
    { title: 'コンテンツ識別ID', sortBy: 0, width: '15%' },
    { title: 'コンテンツ名', sortBy: 1 },
    { title: 'コンテンツ種別', sortBy: 2, width: '10%'},
    { title: 'コース表示名', sortBy: null },
    { title: '実施回数', sortBy: null, width: '7%' },
    { title: '操作', sortBy: null, width: 130 },
  ];

  const itemList =
    itemListInfo &&
    itemListInfo.map((item, index) => {
      const link = Path.USER_HISTORY_CONTENT_DETAIL.replace(':id', item.itemSecernId);
      return (
        <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
          <td>
            {item.contentInfo && item.contentInfo.contentSecernId}
          </td>
          <td>
            {item.contentInfo && item.contentInfo.contentName}
          </td>
          <td>
            {item.contentInfo && getItemBoxName(CONTENT_TYPE_STR, item.contentInfo.contentType)}
          </td>
          <td>
            {item.itemName}
          </td>
          <td className="text-right">
            {(eachItemStatusCount &&
              eachItemStatusCount[item.itemSecernId]) ?
              eachItemStatusCount[item.itemSecernId].itemExecutedCount : 0}
          </td>
          <td className="text-center">
            <CustomLink
              className="margin-right-7 link-detail"
              to={link}
              text="詳細を見る"
              />
          </td>
        </tr>
      );
    });

  return (
    <div>
      <Table striped hover>
        <thead>
          <ReduxFormPaging
            type="tableHead"
            data={thead}
            name="itemSortType"
            handleSortState={handleSortState}
          />
        </thead>
        <tbody>
          {itemList}
        </tbody>
      </Table>
      <Form.Group>
        <Col className="text-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </Form.Group>
    </div>
  );
};

export default ContentHistorySearchResult;
